import React from 'react'
import * as validators from 'constructicon/lib/validators'
import keyBy from 'lodash/keyBy'
import merge from 'lodash/merge'

import RichText from '../../../ui/RichText'

export default ({
  customSupporterPage,
  fundraisingPage,
  tagDefinitions,
  styles
}) => {
  const { fitness = {} } = customSupporterPage

  return {
    fields: merge(
      {},
      fitness.showGoal && {
        fitnessGoal: {
          label: fitness.label || `Fitness goal (in ${fitness.goalUom})`,
          type: 'number',
          required: true,
          initial: fundraisingPage.fitnessGoal,
          validators: [validators.required('Please enter a fitness goal')]
        }
      },
      keyBy(
        tagDefinitions.map(tag => ({
          name: tag.id,
          label: <RichText styles={styles.label}>{tag.label}</RichText>,
          type: 'select',
          placeholder: 'Please select',
          options: tag.values.map(option => ({
            label: option.trim(),
            value: option.trim()
          })),
          required: tag.required,
          initial: fundraisingPage.segmentation[tag.id] || tag.initial,
          validators: tag.required
            ? [validators.required('Please select an option')]
            : []
        })),
        'name'
      )
    )
  }
}
